export default {
  ABORTED_REQUEST: 'The user aborted a request.',
  INVALID_INPUT_ERROR: 'Invalid parameter',
};
